import client from "./client";

const studentsApi = {
  list(params = {}) {
    return client.get("/students", { params }).then((r) => r.data);
  },

  get(id) {
    return client.get(`/students/${id}`).then((r) => r.data);
  },

  create(body) {
    return client.post("/students", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/students/${id}`, body).then((r) => r.data);
  },

  updateStatus(id, status) {
    return client.patch(`/students/${id}/status`, { status }).then((r) => r.data);
  },

  getByClass(classId, params = {}) {
    return client.get(`/students/class/${classId}`, { params }).then((r) => r.data);
  },

  approveExam(studentId, examName) {
    return client.patch(`/students/${studentId}/exams/${examName}/approve`).then((r) => r.data);
  },

  approveClassExam(classId, examName) {
    return client.patch(`/students/class/${classId}/exams/${examName}/approve`).then((r) => r.data);
  },
};

export default studentsApi;
